export interface DeviceBgImgByLanguage {
  [language: string]: {
    desktop: string;
    mobile: string;
  };
}

export const cantoConfig: DeviceBgImgByLanguage = {
  en: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/fb7p608kht6gp4h0t86sjjdb1e/VUxDngrX7kokYtSGAHudBY4xngo/original?content-type=image%2Fjpeg&name=Desktop_USD.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/1dp99sasn12bjbd075mr7ihf52/iJbRRF7Ut_OencweO5X4a8Btc_g/original?content-type=image%2Fjpeg&name=Mobile_USD.jpg',
  },
  my: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/t2ju1v1q0p32v79d4k0e2lqq39/f31o_BDqNarKnswr-kNYRK2xGxo/original?content-type=image%2Fjpeg&name=Desktop_MYR.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/pij8gq4t8161h33bvu12jbdp14/qT_lJHTFvTkxBEptmXHnjn8iExI/original?content-type=image%2Fjpeg&name=Mobile_MYR.jpg',
  },
  id: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/dhs50frhj9489c5itkiih00b2f/98V3GvdRqFP5bGVD1qsn3t7373c/original?content-type=image%2Fjpeg&name=Desktop_IDR.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/cifhtka64p14d88qqd8cog5r6f/6716sV1K8oH0xGJSlvZerb-PRes/original?content-type=image%2Fjpeg&name=Mobile_IDR.jpg',
  },
  th: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/qvpo89jnip737f1skc71gq3307/QXca1JLG3Yd7PBwmsK3Zd9Pl5Hw/original?content-type=image%2Fjpeg&name=Desktop_THB.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/1p0rfou7o124ha1l8vo919d354/Fj00SXppctjgiwqEHW6-EWXWUmw/original?content-type=image%2Fjpeg&name=Mobile_THB.jpg',
  },
  vi: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/ua76rpmpvl1ld54snh2sdc6569/cH9U4Y4QeoL9FgmcGOgTOo9JDPg/original?content-type=image%2Fjpeg&name=Desktop_VND.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/o9j33bf8il2k1f46m61d9sal73/ZuuT0z49KMospzDVQMmqPR69gGE/original?content-type=image%2Fjpeg&name=Mobile_VND.jpg',
  },
  in: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/d2vk2li48l6knegde69eo4lf3k/zuXkF7lbMHRBoEblZZcgm4O0IP4/original?content-type=image%2Fjpeg&name=Desktop_INR.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/gnk7qm6lhl0vv5b5446rov2q32/4E0bNk50QeWSQ_donEIU9vC5GMA/original?content-type=image%2Fjpeg&name=Mobile_INR.jpg',
  },
  jp: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/ca9ks98rqp29t731lku6rqn437/VfFxt0tBBj04iOY9ZvqDgkjynfQ/original?content-type=image%2Fjpeg&name=Desktop_JPY.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/cskstfgnpt0nj3m1j2qr50vl6t/LHs4kQah_FzXW-a1vHGcYNttz-A/original?content-type=image%2Fjpeg&name=Mobile_JPY.jpg',
  },
  kr: {
    desktop:
      'https://mgasia.canto.global/direct/w/promotion/image/tjs7jj5r0p4qr0m8l9gq0imb4p/EH6sQc2Gol7CHn2JJBo-FuN4nno/original?content-type=image%2Fjpeg&name=Desktop_KRW.jpg',
    mobile:
      'https://mgasia.canto.global/direct/w/promotion/image/oba32qio514ghaq2vich37mc0f/9YBII6dAt8qAR_LziRkMmc7y1gQ/original?content-type=image%2Fjpeg&name=Mobile_KRW.jpg',
  },
};
